import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-d-flex p-jc-between" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "logo" }, null, -1)
const _hoisted_3 = { class: "lang" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dropdown = _resolveComponent("Dropdown")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_Dropdown, {
        modelValue: $setup.locale,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.locale) = $event)),
        options: $setup.locales,
        optionLabel: "lang",
        onChange: $setup.switchLanguage
      }, null, 8, ["modelValue", "options", "onChange"])
    ])
  ]))
}